import { graphql } from 'react-apollo';
import gql from 'graphql-tag';

export const CREATE_UPLOAD_QUERY = gql`
  mutation CreateUpload($input: CreateUploadInput!) {
    createUpload(input: $input) {
      id
      presignedUrl
    }
  }
`;

export function withCreateUpload(options) {
  return graphql(CREATE_UPLOAD_QUERY, options);
}
